import { InitPagedData } from './../Utils';
import {MaterialItemCategoryStateTypes,MaterialItemCategoryActionTypes } from "./MaterialItemCategory.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialItemCategoryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged:resetApiCallState(InitPagedData)
};

const MaterialItemCategoryReducer = (
  state: MaterialItemCategoryStateTypes = INITIAL_STATE,
  action: any
): MaterialItemCategoryStateTypes => {
  switch (action.type) {
    case MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialItemCategoryActionTypes.FETCH_ALL_MATERIAL_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };
      case MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY:
        return {
          ...state,
          fetchPaged: {
            error: null,
            payload: InitPagedData,
            isPending: true,
            isSuccessful: false,
          },
        };
      case MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY_RESET:
        return {
          ...state,
          fetchPaged: resetApiCallState(InitPagedData),
        };
      case MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY_FAILURE:
        return {
          ...state,
          fetchPaged: {
            payload: InitPagedData,
            isPending: false,
            isSuccessful: false,
            error: action.payload,
          },
        };
      case MaterialItemCategoryActionTypes.FETCH_PAGED_MATERIAL_ITEM_CATEGORY_SUCCESS:
        return {
          ...state,
          fetchPaged: {
            error: null,
            isPending: false,
            isSuccessful: true,
            payload: action.payload,
          },
        };

    case MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialItemCategoryActionTypes.FETCH_ONE_MATERIAL_ITEM_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialItemCategoryReducer;
